// extracted by mini-css-extract-plugin
export default {"output":"Output_output__Iajw+","error":"Output_error__9P4T8"};